module.exports = __webpack_public_path__ + "static/media/ico_arrow_off.edf672f2.svg";